import { render, staticRenderFns } from "./CompanySidebar.vue?vue&type=template&id=7e7842d6&scoped=true&"
import script from "./CompanySidebar.vue?vue&type=script&lang=js&"
export * from "./CompanySidebar.vue?vue&type=script&lang=js&"
import style0 from "./CompanySidebar.vue?vue&type=style&index=0&id=7e7842d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7842d6",
  null
  
)

export default component.exports